const TOOLTIP_INFO = {
  'Instruction Page': {
    name: 'Liquidity Zone Analysis',
    description:
      'Identifies key support and resistance levels where price tends to consolidate or reverse.',
    strategy: 'Range Trading or Breakout Strategy',
    example:
      'Traders can place buy orders near support zones and sell orders near resistance zones, or wait for a breakout from these levels.',
  },
  'Identify Liquidity Zone': {
    name: 'Liquidity Zone Analysis',
    description:
      'Identifies key support and resistance levels where price tends to consolidate or reverse.',
    strategy: 'Range Trading or Breakout Strategy',
    example:
      'Traders can place buy orders near support zones and sell orders near resistance zones, or wait for a breakout from these levels.',
  },
  'Highlight Liquidity Sweeps': {
    name: 'Liquidity Sweep Analysis',
    description:
      'Identifies price sweeps above or below recent highs and lows, indicating where liquidity might be trapped.',
    strategy: 'Breakout or Reversal Strategy',
    example:
      'Traders can look for a price sweep below a recent low followed by a strong bullish candle to enter a long position, expecting a reversal.',
  },
  'Visualize Order Blocks': {
    name: 'Order Block Analysis',
    description:
      'Identifies areas of significant institutional activity, often marking points of trend continuation or reversal.',
    strategy: 'Trend Continuation or Reversal Strategy',
    example:
      'A trader might enter a short position when the price retraces into a bearish order block within a downtrend.',
  },
  'Track Fair Value Gap': {
    name: 'Fair Value Gap (FVG) Analysis',
    description:
      'Highlights imbalances between buyers and sellers, often leading to price retracements into these gaps.',
    strategy: 'Mean Reversion Strategy',
    example:
      'If a bullish FVG is identified, traders might wait for the price to retrace into the gap before entering a long position.',
  },
  'Track Displayment': {
    name: 'Swing High/Low Analysis',
    description:
      'Marks key turning points in price, helping identify trends and reversal areas.',
    strategy: 'Trend Identification or Reversal Strategy',
    example:
      'Traders can use swing highs as potential resistance and swing lows as support, aligning their trades with the trend direction.',
  },
  'News and Sentiment': {
    name: 'Liquidity Zone Analysis',
    description:
      'Identifies key support and resistance levels where price tends to consolidate or reverse.',
    strategy: 'Range Trading or Breakout Strategy',
    example:
      'Traders can place buy orders near support zones and sell orders near resistance zones, or wait for a breakout from these levels.',
  },
};

export default TOOLTIP_INFO;
